import {Discipline} from "@app/models/shared/discipline.enum";
import {DocumentGeneratorProcessRequest} from "@app/models/automation/documentgenerator/documentGeneratorProcessRequest";

export class DocumentGeneratorProcessRequestWrapper {
  dnaClientId: number;
  files: string[];
  functionCode: string;
  selectedDiscipline?: Discipline;
  documentGeneratorProcessRequests:DocumentGeneratorProcessRequest[];
}
